import {Component, EventEmitter, Injectable, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from 'src/shared/services/user/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
@Injectable()
export class ResetPasswordComponent implements OnInit {
  public form: FormGroup;
  public key: any;
  public activiti: any;
  public email: any;
  public users: any[] = [];
  public resultat: any;
  public userName: any;

  @Input() error: string;
  @Input() loading: boolean;
  public username: String = '';
  @Output()
  connect = new EventEmitter();
  loadingRequestCharges: boolean;

  constructor(
    private fb: FormBuilder,
    public user: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.form = this.fb.group(
      {
        mdp: ['', [Validators.required]],
        mdp_confirm: ['']
      },
      { validator: this.checkPasswords }
    );

    this.key = this.route.snapshot.queryParamMap.get('key');
    this.activiti = this.route.snapshot.queryParamMap.get('activiti');
    this.email = this.route.snapshot.queryParamMap.get('email');
    this.getUserName();
    // if (this.email.includes("@")){
    //   this.resultatEmail = this.route.snapshot.queryParamMap.get('email');
    // }
  }

  getUserName() {
    this.user.transformEmailUsername(this.email).then(res => {
      let i = 0;
      for (i; i < res.people.length; i++) {
        if (res.people[i].email === this.email) {
          this.userName = res.people[i].userName;
        }
      }
    });
  }

  checkPasswords(group: FormGroup) {
    // here we have the 'passwords' group
    const pass = group.get('mdp').value;
    const confirmPass = group.get('mdp_confirm').value;

    return pass === confirmPass ? null : { notSame: true };
  }

  onReset() {
    this.loadingRequestCharges = true;

    this.user
      .updatePass(this.form.value.mdp, this.key, this.activiti, this.userName)
      .then(res => {
        this.router.navigate(['/', 'connexion']);
      })
      .catch(error => {
        this.error = error.error.message;
      })
      .finally(() => (this.loadingRequestCharges = false));
  }

  onReturn() {
    this.router.navigate(['/', 'connexion']);
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(
      control &&
      control.parent &&
      control.parent.invalid &&
      control.parent.dirty
    );

    return invalidCtrl || invalidParent;
  }
}
